<div class="relative inline-block">
  <button pButton type="button" icon="pi pi-bell" class="p-button-rounded p-button-text relative z-10" (click)="openDropdown($event)"></button>
  <span *ngIf="unreadCount > 0" class="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 bg-red-500 text-white rounded-full text-xs px-1 z-20 min-w-[18px] text-center">
    {{ unreadCount }}
  </span>
  <p-overlayPanel #op [showCloseIcon]="true" styleClass="w-80">
    <div class="p-1 p-panel-header text-sm font-semibold mb-1">Notifiche</div>
    <div class="p-panel-content p-0">
      <div *ngIf="isLoading" class="py-4 text-center text-sm">
        <i class="pi pi-spin pi-spinner text-2xl"></i>
      </div>
      <div *ngIf="!isLoading && notifications.length === 0" class="py-2 text-color-secondary text-center text-sm">Nessuna notifica</div>
      <ng-container *ngIf="!isLoading">
        <ng-container *ngFor="let n of displayedNotifications; let last = last">
          <div class="flex items-start py-1 px-2 cursor-pointer p-panel-content min-h-0" [ngClass]="{'font-bold': !n.notification_is_checked}" (click)="markAsRead(n, $event)">
            <div class="flex-1">
              <div class="leading-tight text-sm">{{ n.notification_description }}</div>
              <div class="text-xs text-color-secondary mt-0.5">{{ getNotificationDate(n.notification_created_at) | date:'short' }}</div>
            </div>
            <button *ngIf="!n.notification_is_checked" pButton type="button" icon="pi pi-check" class="p-button-xs p-button-text ml-1" (click)="markAsRead(n, $event)" title="Segna come letta"></button>
          </div>
          <div *ngIf="!last" class="w-full h-px bg-surface-200 my-1" style="background-color: var(--surface-border, #cccccc);"></div>
        </ng-container>
        <div *ngIf="notifications.length > 0" class="border-t border-surface-200 mt-2 pt-2">
          <div *ngIf="remainingUnreadCount > 0" class="text-xs text-color-secondary mb-2 px-2 text-center">
            <i class="pi pi-info-circle mr-1"></i>
            <span>{{ remainingUnreadCount }} alt{{ remainingUnreadCount === 1 ? 'a' : 're' }} non lett{{ remainingUnreadCount === 1 ? 'a' : 'e' }}</span>
          </div>
          <button pButton type="button" label="Visualizza tutte" icon="pi pi-list" class="p-button-text p-button-sm w-full justify-content-start" (click)="openAllNotificationsDialog()"></button>
        </div>
      </ng-container>
    </div>
  </p-overlayPanel>
  <app-notification-list-dialog 
    [(display)]="showAllNotificationsDialog"
    (notificationRead)="onNotificationRead($event)">
  </app-notification-list-dialog>
</div> 